import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import { ChevronsLeft, ChevronsRight } from "lucide-react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import ServicesCard from "./services-card";

interface CarouselProps {
  services: any[];
}

const Carousel = ({ services }: CarouselProps) => {
  return (
    <div className="slide-container relative w-full mx-auto max-w-[1200px]">
      <Swiper
        centeredSlides={true}
        loop={true}
        slidesPerView='auto'
        spaceBetween={30}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // En pantallas medianas, 2 slides
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // En pantallas grandes, 3 slides
          1024: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        }}
        className="customSwiper"
        modules={[EffectCoverflow, Navigation]}
      >
        {services.map((service, index) => (
          <SwiperSlide key={index}>
            <ServicesCard services={[service]} />
          </SwiperSlide>
        ))}

        <div className="relative bottom-[0rem] flex align-center justify-center space-x-5">
          <ChevronsLeft className="h-10 w-10 text-gray-500 cursor-pointer swiper-button-prev" />
          <ChevronsRight className="h-10 w-10 text-gray-500 cursor-pointer swiper-button-next" />
        </div>
      </Swiper>
    </div>
  );
};

export default Carousel;